import React, { ReactNode } from "react";

export class ReactService {
  static renderSlot = (children: ReactNode[], slotName: string) => {
    if (!children) return null;

    const childrenArray = React.Children.toArray(children);

    return childrenArray.find((child) => {
      if (!child) return false;
      return React.isValidElement(child) && child.props.name === slotName;
    });
  };
}
